import {
  alertReadOnly,
  allEntriesUseTiming,
  batchRemoveMultipleEntries,
  getActiveEntries,
  getEntriesWithTiming,
  getFutureEntries,
  getTimingCSS,
} from '@/mixins/commonEntry.js';

var removeTicker = {
  data() {
    return {
      entryToRemove: null,
      showRemoveTickerFromDecoderDialog: false,
    };
  },
  methods: {
    removeTickerFromDecoder(ticker, decoder) {
      let vm = this;
      vm.showRemoveTickerFromDecoderDialog = false;
      vm.entryToRemove = null;
      vm.$nextTick(() => {
        vm.$api
          .deleteTickerFromDecoder(ticker.id, decoder.id)
          .then((response) => {
            vm.$emit('deleted');
            vm.$bus.$emit('alert-success', {
              message: 'entryDeletedSuccess',
              timeout: 2000,
              translate: true,
            });
          });
      });
    },
    // Note: When using delegates like below, make sure all internally
    //   referenced methods are also delegated, otherwise things break
    //   in very subtle ways.
    alertReadOnly: alertReadOnly,
    getActiveEntries: getActiveEntries,
    getFutureEntries: getFutureEntries,
    getTimingCSS: getTimingCSS,
    getEntriesWithTiming: getEntriesWithTiming,
    allEntriesUseTiming: allEntriesUseTiming,
    batchRemoveMultipleEntries: batchRemoveMultipleEntries,
  },
};

export default removeTicker;



// WEBPACK FOOTER //
// ./src/mixins/commonTicker.js